import React from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useReportContext } from "../ReportDataContext";
import SchoolProgramFilters, {
  useSchoolProgramFilters,
} from "../SchoolProgramFilters";
import SchoolProgramAttendanceReportTable from "./SchoolProgramAttendanceReportTable";
import { downloadSchoolProgramAttendanceSheet } from "./schoolProgramAttendanceExcel";
import { sortRows } from "./schoolProgramAttendanceSort";
import { downloadLmsCredentialCards } from "../CampAttendanceReport/lmsCredentialCards";

export default function SchoolProgramAttendanceReportView({ reports }) {
  const branch = useReportContext().AUTH.branch;

  const { filteredReports, filters } = useSchoolProgramFilters(reports, branch, {
    programField: "program_name",
  });

  return (
    <div>
      <SchoolProgramFilters filters={filters} />

      <div className="row mb-3">
        <div className="col-12 text-right">
          <button
            type="button"
            className="btn btn-primary"
            disabled={!filteredReports.length}
            onClick={() =>
              downloadSchoolProgramAttendanceSheet(
                filteredReports,
                branch.branch_name
              )
            }
          >
            Download Attendance Sheet
          </button>
          <DropdownButton
            id="lms-credentials-download"
            variant="primary"
            className="ml-2 d-inline-block"
            title="Download LMS Credentials"
            disabled={!filteredReports.length}
          >
            <Dropdown.Item
              className="d-flex flex-column"
              onClick={() =>
                downloadLmsCredentialCards(
                  filteredReports,
                  branch.branch_name,
                  "camel"
                )
              }
            >
              <span className="font-weight-bold">Camel Case</span>
              <small className="text-muted">e.g. 1234FirstName</small>
            </Dropdown.Item>
            <Dropdown.Item
              className="d-flex flex-column"
              onClick={() =>
                downloadLmsCredentialCards(
                  filteredReports,
                  branch.branch_name,
                  "lower"
                )
              }
            >
              <span className="font-weight-bold">lowercase</span>
              <small className="text-muted">e.g. 1234firstname</small>
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </div>

      {filteredReports.length > 0 ? (
        <SchoolProgramAttendanceReportTable
          reports={sortRows(filteredReports)}
          showActions={false}
        />
      ) : (
        <div className="text-muted mt-3">No results match the selected filters.</div>
      )}
    </div>
  );
}
